(() => {
  'use strict';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const cfg=JSON.parse(document.getElementById('sr-offer-config')?.textContent||'{}');
  const announcement=document.querySelector('.sr-announcement-section');
  if(announcement){
    const update=()=>document.documentElement.style.setProperty('--sr-announcement-height',`${announcement.getBoundingClientRect().height}px`);
    new ResizeObserver(update).observe(announcement);update();
  }
  function initialize(context=document){
    context.querySelectorAll('[data-sr-carousel]:not([data-sr-ready])').forEach(carousel=>{
      carousel.dataset.srReady='true';
      const track=carousel.querySelector('[data-sr-track]'),items=[...track.children];
      if(!items.length)return;
      const rtl=getComputedStyle(track).direction==='rtl';
      const controls=carousel.querySelector('.sr-carousel-controls');
      let index=0,paused=false,hover=false,interacting=false,inView=false;
      function measure(){
        const r=track.getBoundingClientRect();
        index=items.reduce((best,item,i)=>Math.abs((rtl?r.right:r.left)-(rtl?item.getBoundingClientRect().right:item.getBoundingClientRect().left))<Math.abs((rtl?r.right:r.left)-(rtl?items[best].getBoundingClientRect().right:items[best].getBoundingClientRect().left))?i:best,0);
        carousel.querySelector('[data-sr-position]').textContent=`${index+1} / ${items.length}`;
        controls.hidden=track.scrollWidth<=track.clientWidth+2;
      }
      function step(direction){
        const max=track.scrollWidth-track.clientWidth;
        const atEnd=Math.abs(track.scrollLeft)>=max-3;
        if(direction===1&&atEnd){track.scrollTo({left:0,behavior:reduced.matches?'instant':'smooth'});return;}
        if(direction===-1&&Math.abs(track.scrollLeft)<3){track.scrollTo({left:(rtl?-1:1)*max,behavior:reduced.matches?'instant':'smooth'});return;}
        const width=items[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||0);
        track.scrollBy({left:width*direction*(rtl?-1:1),behavior:reduced.matches?'instant':'smooth'});
      }
      carousel.querySelectorAll('[data-sr-direction]').forEach(button=>button.addEventListener('click',()=>{interacting=true;setPause();step((button.dataset.srDirection==='right'?1:-1)*(rtl?-1:1));}));
      const pause=carousel.querySelector('[data-sr-carousel-pause]');
      function setPause(){pause.setAttribute('aria-pressed',String(paused||interacting));pause.textContent=paused||interacting?'▶':'Ⅱ';pause.setAttribute('aria-label',paused||interacting?cfg.play:cfg.pause);}
      pause.addEventListener('click',()=>{paused=!(paused||interacting);interacting=false;setPause();});
      carousel.addEventListener('mouseenter',()=>{hover=true;});carousel.addEventListener('mouseleave',()=>{hover=false;});
      track.addEventListener('pointerdown',()=>{interacting=true;setPause();});
      track.addEventListener('keydown',()=>{interacting=true;setPause();});
      track.addEventListener('scroll',measure,{passive:true});new ResizeObserver(measure).observe(track);
      new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;},{threshold:0.2}).observe(carousel);
      const interval=setInterval(()=>{if(!carousel.isConnected){clearInterval(interval);return;}if(!document.hidden&&!reduced.matches&&!hover&&!paused&&!interacting&&inView&&!carousel.contains(document.activeElement))step(1);},4000);
      measure();
    });
  }
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  const normalTitle=document.title;
  document.addEventListener('visibilitychange',()=>{document.title=document.hidden&&matchMedia('(min-width: 1024px)').matches?cfg.away:normalTitle;});
  // Respect the original form position: sticky controls only appear after it is passed.
  const form=document.querySelector('.hdt-page-type-product .hdt-main-product-form');
  const sticky=document.querySelector('hdt-sticky-btn-atc');
  if(form&&sticky){
    new ResizeObserver(()=>document.documentElement.style.setProperty('--sr-purchase-height',`${sticky.getBoundingClientRect().height+16}px`)).observe(sticky);
    let queued=false;
    function update(){queued=false;const passed=form.getBoundingClientRect().bottom<0;document.body.classList.toggle('sr-sticky-passed',passed);sticky.inert=!passed;sticky.setAttribute('aria-hidden',String(!passed));}
    function schedule(){if(!queued){queued=true;requestAnimationFrame(update);}}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);new ResizeObserver(schedule).observe(form);update();
    const add=form.querySelector('[name=add]');
    if(add&&!reduced.matches){
      let triggered=false;
      const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting&&!triggered&&!add.disabled){triggered=true;setTimeout(()=>{if(!document.hidden&&!reduced.matches&&add.getBoundingClientRect().top<innerHeight){add.classList.add('sr-cta-nudge');add.addEventListener('animationend',()=>add.classList.remove('sr-cta-nudge'),{once:true});}},2200);observer.disconnect();}},{threshold:1});observer.observe(add);
    }
  }
})();
